import React from 'react';
import { useSiteContext } from '../../SiteContext';
import { Alert } from '@material-ui/lab';
export const SlotRenderer = ({ component, slot }) => {
    var _a;
    const { plugins } = useSiteContext();
    const slotComponent = (_a = component.children) === null || _a === void 0 ? void 0 : _a.find(c => c.slot === slot);
    if (!slotComponent)
        return null;
    const plugin = plugins.find(p => p.type === slotComponent.type);
    if (!plugin) {
        return (React.createElement(Alert, { severity: 'error' },
            "Component plugin \"",
            slotComponent.type,
            "\" for \"",
            slotComponent.name,
            "\" not found"));
    }
    return React.createElement(plugin.component, Object.assign({ component: slotComponent }, component.props));
};
export default SlotRenderer;
//# sourceMappingURL=SlotRenderer.js.map